import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "../../../Utils/helper";

const Slider = React.forwardRef(
  (
    {
      className,
      rangeStyle = {}, // Prop để tùy chỉnh style cho Range
      thumbStyle = {}, // Prop để tùy chỉnh style cho Thumb
      ...props
    },
    ref
  ) => (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none select-none items-center ",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-gray-300">
        <SliderPrimitive.Range
          className="absolute h-full rounded-full"
          style={{
            backgroundColor: "#253FF6", // Màu mặc định
            ...rangeStyle, // Ghi đè hoặc thêm style từ props
          }}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          "block h-4 w-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
          "bg-[#253FF6]"
        )}
        style={{
          ...thumbStyle, // Ghi đè hoặc thêm style từ props
        }}
      />
    </SliderPrimitive.Root>
  )
);

Slider.displayName = "Slider";

export default Slider;
